import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../Context";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import referralLink from "../lib/referralLink";
import { Typography, message } from "antd";
import useModalStore from "../StatesStore/ModalStore";
import { InviteFriendsSVG } from "../svgsMobile";

const ShareMenu = ({ componentName, BackgroundOnSvg }) => {
  const { user } = UserAuth();
  const [referralCode, setReferralCode] = useState("");
  const [loading, setLoading] = useState(true);
  const { openModal } = useModalStore();
  const title = "Invite for Social Shopping Experience Now! 😍";
  const textRef = useRef(null); // Create a ref for the Text component

  useEffect(() => {
    if (!user) return;
    const fetchReferralCode = async () => {
      try {
        const userDocRef = doc(db, "users", user?.uid);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();
          if (userData && userData.referralCode) {
            setReferralCode(userData.referralCode);
            setLoading(false);
          }
        }
      } catch (error) {
        console.error("Error fetching referral code:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReferralCode();
  }, [user]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const referralLinkURL = referralLink(referralCode);

  return (
    <div className="position-relative w-100">
      <div
        className="bg-primary-soft-hover d-flex w-100 gap-2 align-items-center"
        id="eventActionShare"
        // data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={() => openModal("Invite", title, referralLinkURL)}
      >
        {componentName === "ProfileDrawer" ? (
          <>
            <div>
              <InviteFriendsSVG />
            </div>
            <div
              className="w-100 textColor"
              style={{
                fontFamily: "Inter",
                fontSize: "1.125rem",
                lineHeight: "100%",
                letterSpacing: "0%",
              }}
            >
              Invite Friends
            </div>
          </>
        ) : componentName !== "AddToChat" ? (
          <div className="d-flex" style={{ gap: "12px" }}>
            <BackgroundOnSvg>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.33333 8.33341C10.1743 8.33341 11.6667 6.84103 11.6667 5.00008C11.6667 3.15913 10.1743 1.66675 8.33333 1.66675C6.49238 1.66675 5 3.15913 5 5.00008C5 6.84103 6.49238 8.33341 8.33333 8.33341Z"
                  stroke="#676A79"
                  stroke-width="1.2"
                />
                <path
                  d="M17.4998 8.33341H15.8332M15.8332 8.33341H14.1665M15.8332 8.33341V6.66675M15.8332 8.33341V10.0001"
                  stroke="#676A79"
                  stroke-width="1.2"
                  stroke-linecap="round"
                />
                <path
                  d="M14.9978 14.9999C14.9998 14.8631 14.9998 14.7241 14.9998 14.5833C14.9998 12.5122 12.0151 10.8333 8.33317 10.8333C4.65127 10.8333 1.6665 12.5122 1.6665 14.5833C1.6665 16.6543 1.6665 18.3333 8.33317 18.3333C10.1923 18.3333 11.533 18.2027 12.4998 17.9694"
                  stroke="#676A79"
                  stroke-width="1.2"
                  stroke-linecap="round"
                />
              </svg>
            </BackgroundOnSvg>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "500",
                fontFamily: "Inter",
                color: "#676A79",
              }}
            >
              Invite Friends
            </div>
          </div>
        ) : (
          <div>Invite Friends</div>
        )}
      </div>
    </div>
  );
};

export default ShareMenu;
